import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Organization } from '../store';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators/map';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthService {
 
  

  private _links = [];
  private _mainLink = { title: 'Authentication', url: '/auth' };

  private _api = '/api/auth';

  links: { title: string; url: any; }[];

  constructor(
    private httpService: HttpService
  ) { }

  getTeamUserRolesByUserID(userID: any) {
    return this.httpService.get(this._api + '/get-team-user-roles-by-user-id-ignore-club-roles/'+userID);
  }

  getTeamsCounts(clubID: number, typeID: number) {
    return this.httpService.get(`${this._api}/get-club-teams-counts/${clubID}/${typeID || 1}`);
  }

  getClubTeamsList(clubID: number, status: number, typeID: number = 1) {
    return this.httpService.get(`${this._api}/get-club-teams-list/${status}/${clubID}/${typeID}`);
  }

  getTeamsList(clubID: number, orgID: number, orgSeasonID: number, status: number) {
    return this.httpService.get(`${this._api}/get-org-club-team-list/${status}/${orgID}/${clubID}/${orgSeasonID}`);
  }

  removeClubTeams(cupfIDs: string, clubID: number) {
    return this.httpService.post(this._api + '/remove-club-teams', { TeamIDs: cupfIDs, ClubID: clubID });
  }

  archiveClubTeams(teamIds: string, clubID: number, status = 0) {
    return this.httpService.post(this._api + `/archive-club-teams/${status}`, { TeamIDs: teamIds, ClubID: clubID });
  }

  getClubTeamPlayersList(clubID: number, teamID: number, status: number) {
    return this.httpService.get(`${this._api}/get-club-team-players-list/${status}/${clubID}/${teamID}`);
  }

  addTeam(clubID: number, data) {
    return this.httpService.post(this._api + `/add-team/${clubID}`, data);
  }

  sendEmail(clubId: number, data) {
    return this.httpService.post(`${this._api}/send-email/${clubId}`, data);
  }

  removePlayers(teamId: number, players: number[]) {
    return this.httpService.post(`${this._api}/remove-players/${teamId}`, players);
  }

  getStatesByCountryID(countryID: number){
    return this.httpService.get(`${this._api}/get-states-by-country-id/${countryID}`);
  }

  addNewTGSAccount(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this._api + '/add-new-account', payload, httpOptions);
  }

  addTeamAdminAccount(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this._api + '/add-team-admin-account', payload, httpOptions);
  }

  resendConfirmationEmail(emailAddress: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    console.log("resendConfirmationEmail => emailAddress ", emailAddress);
    return this.httpService.post(this._api + '/resend-email-confirmation', emailAddress, httpOptions);
  }

  tgsUserSignIn(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this._api + '/tgs-user-sign-in', payload, httpOptions);
  }

  sendPasswordResetEmailLink(payload: any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this._api + '/send-password-reset-email-link', payload, httpOptions);
  }

  loadUserRoles(userID: number){
    return this.httpService.get(`${this._api}/load-user-roles/${userID}`);
  }

  loadUserClubAccountRoles(userID: number){
    return this.httpService.get(`${this._api}/load-user-club-account-roles/${userID}`);
  }

  loadUserTeamAccountRoles(userID: number){
    return this.httpService.get(`${this._api}/load-user-team-account-roles/${userID}`);
  }

  loadUserEventAccountRoles(userID: number){
    return this.httpService.get(`${this._api}/load-user-event-account-roles/${userID}`);
  }

  loadUserCollegeAccountRoles(userID: number){
    return this.httpService.get(`${this._api}/load-user-college-account-roles/${userID}`);
  }

  loadUserHotelAccountRoles(userID: number){
    return this.httpService.get(`${this._api}/load-user-hotel-account-roles/${userID}`);
  }

  loadUserComplexAccountRoles(userID: number){
    return this.httpService.get(`${this._api}/load-user-complex-account-roles/${userID}`);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts